import { Newspaper, Sparkles, Trophy, BookOpen, Download, Zap, Rocket, Gamepad2, Users, Star } from 'lucide-react';

export default function NewsTeaser() {
  return (
    <section id="news" className="py-20 bg-gradient-to-b from-black via-red-900/10 to-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-20 w-96 h-96 bg-red-600 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-yellow-600 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-purple-600 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="bg-gradient-to-br from-red-900/40 via-purple-900/40 to-black border-4 border-yellow-400/50 rounded-2xl p-12 relative overflow-hidden">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,237,0,0.1),transparent_50%)]"></div>

            <div className="relative z-10">
              <div className="flex justify-center mb-6">
                <div className="bg-gradient-to-r from-yellow-400 via-red-500 to-purple-600 p-4 rounded-full animate-bounce">
                  <Sparkles className="text-black" size={48} />
                </div>
              </div>

              <h3 className="font-horizon text-4xl md:text-6xl text-yellow-400 text-center mb-6 neon-glow">
                COMING SOON
              </h3>

              <p className="text-white text-xl md:text-3xl text-center font-bold mb-8 leading-relaxed">
                Your Ultimate Indie Game Dev Resource Hub!
              </p>

              <p className="text-gray-300 text-lg text-center mb-12 max-w-4xl mx-auto leading-relaxed">
                We're cooking up something <span className="text-yellow-400 font-bold">absolutely incredible</span> for you! Get ready for a powerhouse platform that combines everything you need to succeed as an indie developer!
              </p>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
                <div className="bg-gradient-to-br from-red-900/50 to-black border-2 border-red-500/50 rounded-xl p-8">
                  <div className="flex items-center justify-center mb-6">
                    <div className="bg-red-500/20 p-4 rounded-lg border-2 border-red-400">
                      <Newspaper className="text-red-400" size={40} />
                    </div>
                  </div>

                  <h4 className="font-horizon text-3xl text-yellow-400 text-center mb-6">
                    Latest News & Blog
                  </h4>

                  <p className="text-gray-300 text-center mb-8 leading-relaxed">
                    Stay ahead of the curve with breaking news, insights, and stories from the heart of indie game development!
                  </p>

                  <div className="space-y-4">
                    <div className="bg-black/50 border border-red-500/30 rounded-lg p-4 hover:border-red-500 transition-colors hover:scale-105 transition-transform">
                      <div className="flex items-start gap-3">
                        <Trophy className="text-red-400 flex-shrink-0 mt-1" size={24} />
                        <div>
                          <h5 className="text-yellow-400 font-bold mb-1">Featured Indie Games</h5>
                          <p className="text-gray-400 text-sm">
                            Spotlight on incredible indie games and the brilliant minds behind them.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-black/50 border border-red-500/30 rounded-lg p-4 hover:border-red-500 transition-colors hover:scale-105 transition-transform">
                      <div className="flex items-start gap-3">
                        <Zap className="text-blue-400 flex-shrink-0 mt-1" size={24} />
                        <div>
                          <h5 className="text-yellow-400 font-bold mb-1">Tech & AI Deep Dives</h5>
                          <p className="text-gray-400 text-sm">
                            Master the latest tools, frameworks, and AI-powered workflows to supercharge your game dev.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-black/50 border border-red-500/30 rounded-lg p-4 hover:border-red-500 transition-colors hover:scale-105 transition-transform">
                      <div className="flex items-start gap-3">
                        <BookOpen className="text-yellow-400 flex-shrink-0 mt-1" size={24} />
                        <div>
                          <h5 className="text-yellow-400 font-bold mb-1">Honest Game Reviews</h5>
                          <p className="text-gray-400 text-sm">
                            Raw, unfiltered reviews from a developer's perspective. No corporate BS.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-black/50 border border-red-500/30 rounded-lg p-4 hover:border-red-500 transition-colors hover:scale-105 transition-transform">
                      <div className="flex items-start gap-3">
                        <Download className="text-green-400 flex-shrink-0 mt-1" size={24} />
                        <div>
                          <h5 className="text-yellow-400 font-bold mb-1">Free Resources</h5>
                          <p className="text-gray-400 text-sm">
                            Premium assets, templates, and tools - completely free for the community.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-purple-900/50 to-black border-2 border-purple-500/50 rounded-xl p-8">
                  <div className="flex items-center justify-center mb-6">
                    <div className="bg-purple-500/20 p-4 rounded-lg border-2 border-purple-400">
                      <Rocket className="text-purple-400" size={40} />
                    </div>
                  </div>

                  <h4 className="font-horizon text-3xl text-yellow-400 text-center mb-6">
                    WFP Studio Projects
                  </h4>

                  <p className="text-gray-300 text-center mb-8 leading-relaxed">
                    Get an exclusive first look at what we're building at WFP Studio. Innovation meets creativity!
                  </p>

                  <div className="space-y-4">
                    <div className="bg-black/50 border border-purple-500/30 rounded-lg p-4 hover:border-purple-500 transition-colors hover:scale-105 transition-transform">
                      <div className="flex items-start gap-3">
                        <Gamepad2 className="text-purple-400 flex-shrink-0 mt-1" size={24} />
                        <div>
                          <h5 className="text-yellow-400 font-bold mb-1">Klick-Pop</h5>
                          <p className="text-gray-400 text-sm">
                            A vibrant K-Pop-themed clicker game packed with rhythm, charm, and surprising new features that reinvent the classic clicker experience.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-black/50 border border-purple-500/30 rounded-lg p-4 hover:border-purple-500 transition-colors hover:scale-105 transition-transform">
                      <div className="flex items-start gap-3">
                        <Zap className="text-blue-400 flex-shrink-0 mt-1" size={24} />
                        <div>
                          <h5 className="text-yellow-400 font-bold mb-1">Shadow & Light</h5>
                          <p className="text-gray-400 text-sm">
                            Your ultimate AI assistant and D&D dungeon master. Powered by cutting-edge AI to bring your adventures to life.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-black/50 border border-purple-500/30 rounded-lg p-4 hover:border-purple-500 transition-colors hover:scale-105 transition-transform">
                      <div className="flex items-start gap-3">
                        <BookOpen className="text-orange-400 flex-shrink-0 mt-1" size={24} />
                        <div>
                          <h5 className="text-yellow-400 font-bold mb-1">Stuper Man</h5>
                          <p className="text-gray-400 text-sm">
                            A hilarious graphic novel twist on the superhero genre. Expect the unexpected! (Working Title)
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-black/50 border border-purple-500/30 rounded-lg p-4 hover:border-purple-500 transition-colors hover:scale-105 transition-transform">
                      <div className="flex items-start gap-3">
                        <Star className="text-yellow-400 flex-shrink-0 mt-1" size={24} />
                        <div>
                          <h5 className="text-yellow-400 font-bold mb-1">More Projects Coming Soon</h5>
                          <p className="text-gray-400 text-sm">
                            Exciting new projects and publishing opportunities on the horizon. Stay tuned for updates!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-red-900/30 via-purple-900/30 to-black border-l-4 border-yellow-400 rounded-lg p-6 mb-8">
                <p className="text-white text-center text-xl md:text-2xl italic leading-relaxed">
                  "This isn't just another blog. It's a <span className="text-yellow-400 font-bold">complete arsenal</span> of knowledge, resources, and inspiration designed to help indie devs <span className="text-red-400 font-bold">dominate</span> the gaming industry."
                </p>
              </div>

              <div className="bg-black/60 border-2 border-yellow-400/50 rounded-xl p-6 mb-6">
                <h5 className="text-yellow-400 font-bold text-xl text-center mb-4">What You'll Get:</h5>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
                  <div>
                    <p className="text-3xl font-bold text-white mb-1">Weekly Updates</p>
                    <p className="text-gray-400 text-sm">Fresh content every week</p>
                  </div>
                  <div>
                    <p className="text-3xl font-bold text-white mb-1">Expert Insights</p>
                    <p className="text-gray-400 text-sm">From proven industry veterans</p>
                  </div>
                  <div>
                    <p className="text-3xl font-bold text-white mb-1">100% Free</p>
                    <p className="text-gray-400 text-sm">No paywalls, no BS</p>
                  </div>
                </div>
              </div>

              <div className="text-center">
                <div className="inline-flex items-center gap-3 bg-black/70 border-2 border-yellow-400/50 rounded-full px-10 py-5 mb-4">
                  <div className="w-4 h-4 bg-yellow-400 rounded-full animate-ping"></div>
                  <span className="text-yellow-400 font-bold text-xl">Launching Soon</span>
                </div>
                <p className="text-gray-300 text-lg mb-2">
                  We're building something epic. Follow us for launch updates!
                </p>
                <p className="text-purple-400 text-sm">
                  Join the community and be the first to know when we drop 🚀
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
